export enum ActivitySequenceMatrixMode {
	display = 'display',
	schedule = 'schedule',
}
